var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstaWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.31,
    height: 36.31,
    "data-name": "Group 776",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.405 9.489h-8.5a4.4 4.4 0 0 0-4.39 4.386v8.5a4.4 4.4 0 0 0 4.391 4.392h8.5a4.4 4.4 0 0 0 4.392-4.392v-8.5a4.4 4.4 0 0 0-4.393-4.386m-4.162 13.886a5.242 5.242 0 1 1 5.242-5.242 5.25 5.25 0 0 1-5.242 5.242m5.548-9.589a1.248 1.248 0 1 1 1.248-1.248 1.25 1.25 0 0 1-1.249 1.245Z",
    "data-name": "Path 554"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.156 0A18.155 18.155 0 1 0 36.31 18.154 18.155 18.155 0 0 0 18.156 0m10.642 22.379a6.4 6.4 0 0 1-6.393 6.395h-8.5a6.4 6.4 0 0 1-6.393-6.395v-8.5a6.4 6.4 0 0 1 6.393-6.393h8.5a6.4 6.4 0 0 1 6.393 6.393Z",
    "data-name": "Path 555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.242 14.771A3.358 3.358 0 1 0 21.6 18.13a3.36 3.36 0 0 0-3.358-3.359",
    "data-name": "Path 556"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaWhite);
export default __webpack_public_path__ + "static/media/instaWhite.3c8c1b341d4e0f5d1677d087337b8b5d.svg";
export { ForwardRef as ReactComponent };